module.exports = __webpack_public_path__ + "static/media/avatars_male_17.a61f88f5.png";